import React from 'react';
import { Clock } from 'lucide-react';

/**
 * Small pill badge that surfaces when a legal document was last updated.
 * Sits in the page header next to the Back button so visitors can immediately
 * tell whether the policy is current.
 */
export default function LastUpdatedBadge({ date, className = '' }) {
  if (!date) return null;
  return (
    <span
      className={`inline-flex items-center gap-1.5 px-2.5 py-1 rounded-full text-xs font-medium bg-emerald-50 text-emerald-700 border border-emerald-200 dark:bg-emerald-950 dark:text-emerald-300 dark:border-emerald-800 ${className}`}
      data-testid="last-updated-badge"
      title={`Last updated: ${date}`}
    >
      <Clock className="w-3 h-3" />
      <span className="hidden sm:inline">Updated </span>
      <span>{date}</span>
    </span>
  );
}
